export type PasswordStrength = "empty" | "weak" | "medium" | "strong";

export function getPasswordStrength(password: string): PasswordStrength {
  if (!password) return "empty";

  const checks = [
    /[a-z]/.test(password), // lowercase
    /[A-Z]/.test(password), // uppercase
    /[0-9]/.test(password), // digit
    /[^a-zA-Z0-9]/.test(password), // symbol
  ];
  const passed = checks.filter(Boolean).length;

  if (password.length < 6) return "weak";
  if (password.length < 8 || passed < 2) return "weak";
  if (passed < 3) return "medium";
  return "strong";
}
